//프로젝트별 수주품의서 히스토리
import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as projectApi from '../../lib/api/project';

const [
  LIST_PROJECT_ORDERS,
  LIST_PROJECT_ORDERS_SUCCESS,
  LIST_PROJECT_ORDERS_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_ORDERS');
export const listProjectOrders = createAction(
  LIST_PROJECT_ORDERS,
  (searchData) => searchData,
);
const listProjectOrdersSaga = createRequestSaga(
  LIST_PROJECT_ORDERS,
  projectApi.getProjectOrders,
);

const UNLOAD_PROJECT_ORDERS = 'project/UNLOAD_PROJECT_ORDERS';
export const unloadProjectOrders = createAction(UNLOAD_PROJECT_ORDERS);

const SET_PROJECT_ORDERS_FITERS = 'project/SET_PROJECT_ORDERS_FITERS';
export const setProjectOrdersFilters = createAction(
  SET_PROJECT_ORDERS_FITERS,
  (filters) => filters,
);

const RESET_PROJECT_ORDERS_FILTERS = 'project/RESET_PROJECT_ORDERS_FILTERS';
export const resetProjectOrdersFilters = createAction(
  RESET_PROJECT_ORDERS_FILTERS,
);

export function* projectOrdersSaga() {
  yield takeLatest(LIST_PROJECT_ORDERS, listProjectOrdersSaga);
}

const initialState = {
  orderLetters: null,
  error: null,
  defaultFilters: {
    searchKeyword: 'cstNm',
    searchWords: '',
    searchStrtDt: null,
    searchEndDt: null,
  },
};

const projectOrders = handleActions(
  {
    [LIST_PROJECT_ORDERS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      orderLetters: data.list.map((orderLetter) => ({
        id: orderLetter.roUuid,
        roUuid: orderLetter.roUuid,
        roNo: orderLetter.roNo,
        cstNm: orderLetter?.cstNm,
        partnerUuid: orderLetter.partnerUuid,
        partnerNm: orderLetter.partnerNm,
        employeeUuid: orderLetter.employeeUuid,
        employeeNm: orderLetter.employeeNm,
        partnerInc: orderLetter.partnerInc,
        chargeNm: orderLetter.chargeNm,
        salesUuid: orderLetter.salesUuid,
        salesNm: orderLetter.salesNm,
        expDay: orderLetter.expDay,
        siDt: orderLetter.siDt,
        mtnFreeTm: orderLetter.mtnFreeTm,
        mtnFreeStrtDt: orderLetter.mtnFreeStrtDt,
        mtnFreeEndDt: orderLetter.mtnFreeEndDt,
        collCondt: orderLetter.collCondt,
        payCondt: orderLetter.payCondt,
        ordYn: orderLetter.ordYn,
        crtNm: orderLetter.crtNm,
        crtDt: orderLetter.crtDt,
        cngNm: orderLetter.cngNm,
        cngDt: orderLetter.cngDt,
      })),
      error: null,
    }),
    [LIST_PROJECT_ORDERS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_PROJECT_ORDERS]: () => initialState,
    [RESET_PROJECT_ORDERS_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_PROJECT_ORDERS_FITERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default projectOrders;
